import React, { useState } from 'react'
import { useSwiper } from 'swiper/react'
import { to400Image } from '~/utils'
import styles from './Navigation.module.css'
import classNames from 'classnames'
import { ImageType } from '.'

const Navigation = ({ images }: { images: ImageType[] }) => {
  const [index, setIndex] = useState(0)
  const swiper = useSwiper()
  swiper.on('slideChange', item => {
    setIndex(item.realIndex)
  })
  return (
    <div
      className="absolute bottom-0 left-0 right-0 z-10"
      onClick={e => {
        e.stopPropagation()
      }}
    >
      <div className="flex justify-center items-center mx-auto bg-neutral-50/50 backdrop-blur-lg py-2">
        {images.map((it, i) => (
          <div
            key={it.url}
            className={classNames(styles.navigation, 'flex-shrink-0', {
              active: index === i,
            })}
            onClick={() => {
              swiper.slideToLoop(i)
            }}
            style={{
              width: 40,
              // it.width && it.height
              //   ? Math.floor((80 * it.width) / it.height)
              //   : 80,
            }}
          >
            <img
              className="rounded overflow-hidden object-cover"
              src={to400Image(it.url)}
              alt=""
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default Navigation
